module.exports = __webpack_public_path__ + "img/4_25.893a84ac.png";